import {createTheme} from '@mui/material/styles';
import OpenSansRegular from '../assets/fonts/OpenSans/OpenSans-Regular.ttf';
const theme = createTheme({
    palette: {
        primary: {
            main: '#FF9A00',
        },
        secondary: {
            main: '#132356',
            light: '#FFCA78',
        },
        background: {
            paper: '#f7f7f7',
            default: '#ffffff',
        },
        text: {
            primary: '#59617b',
            secondary: 'rgba(204, 204, 204, 0.75)',
            disabled: 'rgba(0,0,0,0.85)',
        },
        info: {
            main: '#fff7ea',
            light: '#FFDCA6',
        },
        error: {
            main: '#F14437',
        },
        action: {
            disabledBackground: '#E0E0E0',
            disabled: '#fff',
        },
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1200,
            xl: 1536,
            // xs: 0,
            // sm: 576,
            // md: 768,
            // lg: 992,
            // xl: 1200,
        },
    },
    typography: {
        fontFamily: "'proxima-nova', 'OpenSans', sans-serif",
    },
});

export default theme;
